import { render } from "./_From.vue?vue&type=template&id=82facfca&scoped=true"
import script from "./_From.vue?vue&type=script&lang=js"
export * from "./_From.vue?vue&type=script&lang=js"

import "./_From.vue?vue&type=style&index=0&id=82facfca&scoped=true&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82facfca"]])

export default __exports__